import React from "react";
import { Link } from "react-router-dom";

export default function Events() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">
        Upcoming Events
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {/* Men’s Conference 2025 Card */}
        <div className="bg-white shadow-md rounded-lg p-6 flex flex-col justify-between">
          <div>
            <h2 className="text-xl font-bold text-gray-800 mb-2">
              Men’s Conference 2025
            </h2>
            <p className="text-gray-600 mb-4 italic">
              Faithful Stewards of God’s Grace
            </p>
            <p className="text-gray-700">
              October 24–25, 2025 <br />
              Location: Calvary Baptist – Calvary Center
            </p>
          </div>

          <div className="mt-6 flex justify-center">
            <Link
              to="/mens-conference-2025"
              className="px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-800 transition"
            >
              View Details
            </Link>
          </div>
        </div>

        {/* Future events can be added here the same way */}
      </div>
    </div>
  );
}
